const elements = document.getElementsByClassName('cookie-einstellungen')
for (let i = 0; i < elements.length; i++) {
  // eslint-disable-next-line func-names
  elements[i].addEventListener('click', function (event) {
    event.preventDefault()
    let cmpId = elements[i].getAttribute('data-cmp-id')
    window._sp_.loadPrivacyManagerModal(cmpId)
  })
}
